import React from 'react';
import { Card } from '../ui/Card';
export function MapLegend() {
  return <Card className="absolute bottom-6 left-6 z-[400] w-64 !p-4 shadow-float border-0 bg-white/95 backdrop-blur-sm" data-id="element-50">
      <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3" data-id="element-51">
        Bewertungs-Score
      </h4>

      <div className="space-y-3" data-id="element-52">
        <div className="flex items-center justify-between" data-id="element-53">
          <div className="flex items-center gap-2" data-id="element-54">
            <div className="w-3 h-3 rounded-full bg-status-success shadow-[0_0_8px_rgba(34,197,94,0.4)]" data-id="element-55"></div>
            <span className="text-sm font-medium text-gray-700" data-id="element-56">
              Exzellent (&gt;4.5)
            </span>
          </div>
          <span className="text-xs font-bold text-gray-900" data-id="element-57">342</span>
        </div>

        <div className="flex items-center justify-between" data-id="element-58">
          <div className="flex items-center gap-2" data-id="element-59">
            <div className="w-3 h-3 rounded-full bg-status-warning shadow-[0_0_8px_rgba(234,179,8,0.4)]" data-id="element-60"></div>
            <span className="text-sm font-medium text-gray-700" data-id="element-61">
              Durchschnitt (3.5-4.5)
            </span>
          </div>
          <span className="text-xs font-bold text-gray-900" data-id="element-62">286</span>
        </div>

        <div className="flex items-center justify-between" data-id="element-63">
          <div className="flex items-center gap-2" data-id="element-64">
            <div className="w-3 h-3 rounded-full bg-status-danger shadow-[0_0_8px_rgba(239,68,68,0.4)]" data-id="element-65"></div>
            <span className="text-sm font-medium text-gray-700" data-id="element-66">
              Kritisch (&lt;3.5)
            </span>
          </div>
          <span className="text-xs font-bold text-gray-900" data-id="element-67">42</span>
        </div>
      </div>

      <div className="mt-4 pt-3 border-t border-gray-100" data-id="element-68">
        <div className="text-xs text-gray-500" data-id="element-69">
          <span className="font-medium text-obi-orange" data-id="element-70">42 Filialen</span> im
          kritischen Bereich erfordern Aufmerksamkeit.
        </div>
      </div>
    </Card>;
}